import { render } from "./ProjectSubMenu.vue?vue&type=template&id=14d628c4&scoped=true"
import script from "./ProjectSubMenu.vue?vue&type=script&lang=js"
export * from "./ProjectSubMenu.vue?vue&type=script&lang=js"

import "./ProjectSubMenu.vue?vue&type=style&index=0&id=14d628c4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d628c4"]])

export default __exports__